<template>
  <div class="hpanel">
    <div class="panel-body">
      <template v-if="paymentStatus === false && (plan && plan.amount !== 0)">
        <div class="row">
          <div class="col-xs-12 text-center">
            <h3 class="m-b-xs text-center">You will be redirected on payment page</h3>
            <div class="col-md-2"></div>
            <div class="col-md-8">
              <div class="progress full m-t-xs" style="margin: 40px 0">
                <div class="progress-bar progress-bar-striped active progress-bar-info" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%">
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="row">
          <div class="col-xs-12 text-center">
            <h5 class="text-success">Successful !</h5>
            <div class="m-t">
              Thanks for choosing us, if you have any question you can use the support widget (bottom right).
            </div>

            <div class="m-t">
              You can access your plans details in your Profile Page (click on your name), section <b>Plan & Quotas</b>
            </div>

            <div class="m-t" v-if="plan && plan.amount !== 0">
              You can retrieve your bills in your Profile Page, section <b>Bills</b>
            </div>

            <a @click="redirectAfterPayment" class="btn btn-info" style="margin-top: 25px">Continue</a>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

import VueSlider from 'vue-slider-component'
import VueLadda from 'vue-ladda'

const stripe = Stripe(process.env.STRIPE)

export default {
  components: {
    VueSlider,
    VueLadda
  },
  name: 'Payment',
  props: {
    plan: {
      required: true,
      default: null
    },
    paymentStatus: {
      required: true,
      default: false
    }
  },
  data () {
    return {
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  methods: {
    getResources: function () {
      this.init()
    },
    init: function () {
      let trial = localStorage.getItem('trial') === 'true'

      if (this.plan && this.paymentStatus === false) {
        this.$salesMachine.initPaymentProcess()
        this.axios.get('payment/init/' + this.plan.id + '?trial=' + trial).then((response) => {
          if (response.data.length !== 0) {
            this.$salesMachine.stripeCheckout()
            stripe.redirectToCheckout({ sessionId: response.data.id }).then((response) => {
            })
          } else {
            this.$salesMachine.paymentSuccess()
            if (trial) {
              this.$salesMachine.setTrialStartDate(this.$moment())
            }
            setTimeout(() => {
              this.$auth.fetch()
            }, 5000)
            this.$router.resolve({name: 'Plans', params: {}, query: {'paymentStatus': true}})
          }
          localStorage.removeItem('trial')
        }).catch((error) => {
        })
      }
    },
    redirectAfterPayment: function (event) {
      let registerRedirect = localStorage.getItem('register_redirect')

      let goTo
      if (registerRedirect !== null) {
        localStorage.removeItem('register_redirect')
        goTo = {path: registerRedirect}
      } else {
        goTo = {name: 'Dashboard'}
      }
      this.$router.push(goTo)
    }
  },
  mounted () {
    this.getResources()
  }
}
</script>
}



// WEBPACK FOOTER //
// src/pages/plan/Payment.vue